import React from 'react';
import { Link } from 'react-router-dom';

const Projects = () => {
    return (
        <div>
            <h1 className='text-4xl my-12 font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-500 to-blue-500'>MY PROJECTS</h1>

            <div className='grid lg:grid-cols-3 md:grid-cols-2 mx-14'>

                <div class="card w-96 bg-base-100 shadow-2xl">
                    <figure><img src="https://content3.jdmagicbox.com/comp/jaipur/u3/0141px141.x141.200304181427.q7u3/catalogue/jaipur-strong-js-fitness-academy-jaipur-10egvsgdht.jpg?clr=662a00" alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">Robinho-Fitness trainer Academy</h2>
                        <p>This is improves Your body balance, recovers every kind of bone pain And loose significant weight</p>
                        <div class="card-actions justify-end">
                            <button class="btn btn-primary mx-auto bg-orange-500"> <a target='blank' href="https://gym-body-builder.firebaseapp.com/">visit site</a> </button>
                            <button className='btn btn-primary mx-auto bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none'>  <Link to='/fitness'>Details</Link></button>
                        </div>
                    </div>
                </div>

                <div class="card w-96 bg-base-100 shadow-2xl">
                    <figure><img src="http://www.adlittle.com/sites/default/files/viewpoints/future_car_sales_cover.jpg" alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">Car-Warehouse-management website</h2>
                        <p>The stunning collection of Cars, which has grown gradually at the site on a business park in Tottenham have been given guide.</p>
                        <div class="card-actions justify-end">
                            <button class="btn btn-primary mx-auto bg-orange-500"> <a target='blank' href="https://fir-manage-assignment.web.app/">visit site</a> </button>
                            <button className='btn btn-primary mx-auto bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none'>  <Link to='/car'>Details</Link></button>
                        </div>
                    </div>
                </div>

                <div class="card w-96 bg-base-100 shadow-2xl">
                    <figure><img src="https://c8.alamy.com/comp/JAXDTY/collection-of-ladies-handbags-isolated-on-white-background-JAXDTY.jpg" alt="Shoes" /></figure>
                    <div class="card-body">
                        <h2 class="card-title">Ladies-Bag Shopping website</h2>
                        <p>It is a virtual shopping Mall.It is developed by me.It is one of the most populer online shop in Bangladesh</p>
                        <div class="card-actions justify-end">
                            <button class="btn btn-primary mx-auto bg-orange-500"> <a target='blank' href="https://glowing-muffin-748e3c.netlify.app/">visit site</a> </button>
                            <button className='btn btn-primary mx-auto bg-gradient-to-r from-green-400 to-blue-500 hover:from-pink-500 hover:to-yellow-500 text-slate-100 border-none'>  <Link to='/ladiesbag'>Details</Link></button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default Projects;